export enum Role {
  Administrator = 'Administrator',
  ScanCheck = 'ScanCheck',
  ScanReview = 'ScanReview',
  Migration = 'Migration',
  PreferenceAdmin = 'PreferenceAdmin',
  ChangeRequest = 'ChangeRequest',
  LayingUpAdmin = 'LayingUpAdmin',
  ScanImporter = 'ScanImporter',
}

export const Roles = Object.values(Role);
